import { createResourceModule } from '../../../lib/resource/module.js';
import { paymentGatewayDetail } from './schemas.js';

/**
 * The Payment Gateways module's API layer.
 *
 * The CRUD paths and hooks come from the shared factory; the module only
 * supplies its resource name, base path and detail schema.
 */
export const paymentGateways = createResourceModule({
  resource: 'paymentGateways',
  basePath: '/v1/payment-gateways',
  detail: paymentGatewayDetail,
});

export const paymentGatewayEndpoints = paymentGateways.endpoints;
